import appWorker from '@/worker';

export const setIDBVersion = (version: string) => {
  return appWorker.request('idb', 'clearAllStore').then(() =>
    appWorker.request('idb', 'set', {
      key: 'value',
      value: version,
      storeName: 'version',
    }),
  );
};

export const splitDirPathAndFileName = (path: string) => {
  const fileName = path.split('/').pop();
  const dirPath = path.replace(`/${fileName}`, '');

  if (!fileName) throw new Error(`Invalid path: ${path}`);

  return { fileName, dirPath };
};

export const parsePcdPathAsync = (path: string) => {
  try {
    return Promise.resolve(splitDirPathAndFileName(path));
  } catch (error) {
    return Promise.reject(error);
  }
};
